import React from 'react';

const ACCENTS = {
  ocean:   'border-l-4 border-l-ocean-500',
  sand:    'border-l-4 border-l-sand-500',
  reef:    'border-l-4 border-l-reef-500',
  success: 'border-l-4 border-l-emerald-500',
  danger:  'border-l-4 border-l-red-500',
  warning: 'border-l-4 border-l-amber-500',
};

export default function Card({ children, className = '', hover = false, accent }) {
  return (
    <div className={`card ${hover ? 'hover:shadow-card-hover transition-shadow duration-150 cursor-pointer' : ''} ${accent ? ACCENTS[accent] : ''} ${className}`}>
      {children}
    </div>
  );
}
